import React from "react";
import ReactDOM from "react-dom";
import Layers from "../../Canvas/Layers";
import CloseIcon from "../../Layout/Icons/CloseIcon";

class ZoomContainer extends React.Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown, false);
    document.addEventListener("click", this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
    document.removeEventListener("click", this.handleClick, false);
  }

  handleClick = (event) => {
    if (!ReactDOM.findDOMNode(this).contains(event.target)) {
      this.props.handleCloseZoom();
    }
  };

  handleKeyDown = (event) => {
    const ESCAPE_KEY = 27;
    if (event.keyCode === ESCAPE_KEY) {
      this.props.handleCloseZoom();
    }
  };

  render() {
    return (
      <div className="zoom__container">
        <button
          className="button button--close-zoom"
          onClick={(event) => {
            event.stopPropagation();
            this.props.handleCloseZoom();
          }}
        >
          <CloseIcon />
        </button>

        <div className="zoom__wrapper">
          <div className="zoom__layers">
            <Layers disableInteractivity={true} />
          </div>
        </div>
      </div>
    );
  }
}

export default ZoomContainer;
